const id_contract = {
    add: "tambah kontrak",
    edit: "ubah kontrak",
    detail: "detail kontrak",

    label: {
        contract_date: 'tanggal kontrak',
        contract_num: 'no. kontrak',
        contract_period: 'periode kontrak',
        contract_amout: 'nilai kontrak',
        contract_content: 'isi kontrak',
    },

    message: {
        delete_po_title: "Apakah Anda yakin untuk membatalkan kontrak?",
        delete_po_text: "Masukkan alasan pembatalan kontrak.",

        reject_po_title: "Apakah Anda yakin untuk menolak kontrak?",
        reject_po_text: "Masukkan alasan penolakan kontrak.",
    },

    error: {
        create: "Gagal membuat kontrak.",
        delete: "Gagal membatalkan kontrak.",
        edit: "Gagal mengubah kontrak.",
    },

    success: {
        create: "Berhasil membuat kontrak.",
        delete: "Berhasil membatalkan kontrak.",
        edit: "Berhasil mengubah kontrak.",
    },
}

export default id_contract;